import { batchExecutionDetailsModalReducerKey } from './BatchExecutionDetailsModalConstants';

export const batchExecutionDetailsModal = (state) => {
  return state.get(batchExecutionDetailsModalReducerKey);
};

export const isLoading = (state) => {
  return batchExecutionDetailsModal(state).get('isLoading');
};

export const queries = (state) => {
  return batchExecutionDetailsModal(state).get('queries');
};

export const filename = (state) => {
  return batchExecutionDetailsModal(state).get('filename');
};

export const context = (state) => {
  return batchExecutionDetailsModal(state).get('context');
};

export const options = (state) => {
  return batchExecutionDetailsModal(state).get('options');
};

export const detailsList = (state) => {
  return batchExecutionDetailsModal(state).get('detailsList');
};

export const isShowPictures = (state) => {
  return batchExecutionDetailsModal(state).get('isShowPictures');
};
